import { MemberDto } from '@/services/api'
import { MemberRoleEnumLabels } from './constants'
import { WasteContainerDto } from '@/services/dtos'

export const getNameWithRole = (member: MemberDto) => {
  if (!member) {
    return ''
  }
  const roleLabel = MemberRoleEnumLabels[member.role]
  return `${member.firstName} ${member.lastName}${
    roleLabel ? ` (${roleLabel})` : ''
  }`
}

export const getContainerSubTitles = (container: WasteContainerDto) => {
  return [
    container.label,
    `${container.wasteEntryCount} déchet${container.wasteEntryCount > 1 ? 's' : ''}`,
  ]
}
